import GenderEthnicityChart from './GenderEthnicityChart';
export default GenderEthnicityChart;
